import React from "react";
import HeroCustom from './herocustom';
import SynectiksForAllSection from './for_all';
import TalentSection from "./Talent";
import LifeAtSynectiksSection from "./lifeAtSynectiks";
import Positions from "./positions";


function Index() {
    return (
        <div>
            <HeroCustom />
            <TalentSection />
            <LifeAtSynectiksSection />
            {/* <OpenPositionsSection /> */}   
            <Positions />
            <SynectiksForAllSection />
        </div>

    );
}

export default Index;